import React, {useState} from "react";
import {Popover} from "@mui/material";
import {Svg} from "assets";

export const Settings = ({list = ()=>{}, currentITem, mainLeg, className}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const toggleMenu = (event) => {
        event ? setAnchorEl(event?.currentTarget) : setAnchorEl(null);
    };

    return (
        <div className={`settings-wrapper ${className ? className : ''}`}>
            <div className={"settings-icon-wrapper"} onClick={toggleMenu}>
                <Svg.SettingsSvg/>
            </div>

            {!!list(currentITem)?.length && (
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={() => toggleMenu()}
                    className={"settings-menu"}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                >
                    {list(currentITem, mainLeg)?.filter((listItem) => listItem)?.map(({Svg, text, handleClick}, index) => (
                        <div
                            key={index}
                            className="settings-item-wrapper"
                            onClick={(e) => handleClick && handleClick(e, toggleMenu, currentITem)}
                        >
                            {Svg && <Svg/>}
                            {text && <p className="settings-text">{text}</p>}
                        </div>
                    ))}
                </Popover>
            )}
        </div>
    );
};
